// Generated by CoffeeScript 2.7.0
var Integer;

Integer = class Integer {
  constructor(element1) {
    this.element = element1;
    this.bindEvent();
  }

  bindEvent() {
    return this.element.addEventListener('keypress', this.validateKeycode, false);
  }

  validateKeycode(event) {
    var regex;
    regex = /[\-.\d]/g;
    if (!regex.test(event.key)) {
      return event.preventDefault();
    }
  }

};

Vue.directive('integer', {
  bind: function(element) {
    return element.integer = new Integer(element);
  },
  unbind: function(element) {
    if (element.integer) {
      element.integer.element.removeEventListener('keypress', element.integer.validateKeycode, false);
      return delete element.integer;
    }
  }
});
